import React, { useState, useEffect } from 'react';
import '../../styles/service-style/medical-rehabilitation.css';
import Footer from '../../components/Footer';
import { ChevronDown, ChevronUp } from 'lucide-react';
import employeeImage from '../../assets/founder.jpg';

// const teamMembers = [
//   {
//     name: 'S. Madhu Goud',
//     role: 'Frontend Developer | UI/UX Designer',
//     bio: 'Passionate about building user-friendly interfaces.',
//     image: employeeImage,
//   },
//   {
//     name: 'Charan',
//     role: 'Full Stack Developer',
//     bio: 'Loves solving complex problems with elegant code.',
//     image: employeeImage,
//   },
//   {
//     name: 'Rahul Sharma',
//     role: 'Data Scientist',
//     bio: 'Data enthusiast with a love for AI and ML.',
//     image: employeeImage,
//   },
// ];

const sections = [
  {
    title: 'In-Patient Services',
    items: [
      { heading: 'Comprehensive Assessment', content: "Our team conducts a comprehensive assessment to identify the individual's mental health needs and develop a personalized treatment plan." },
      { heading: 'Medication Management', content: 'Our psychiatrists provide medication management to help stabilize symptoms and promote recovery.' },
      { heading: 'Individual and Group Therapy', content: 'Our therapists provide individual and group therapy sessions to address a range of mental health concerns, including anxiety, depression, and trauma.' },
      { heading: 'Family Therapy', content: 'Our team provides family therapy to support loved ones and promote healthy communication and relationships.' },
      { heading: 'Recreational Therapy', content: 'Our recreational therapists provide activities and programs to promote socialization, relaxation, and stress management.' },
      { heading: 'Discharge Planning', content: 'Our team works with individuals and their families to develop a discharge plan, ensuring a smooth transition to out-patient care.' },
    ],
  },
  {
    title: 'Out-Patient Services',
    items: [
      { heading: 'Comprehensive Assessment', content: "Our team conducts a comprehensive assessment to identify the individual's mental health needs and develop a personalized treatment plan." },
      { heading: 'Medication Management', content: 'Our psychiatrists provide medication management to help stabilize symptoms and promote recovery.' },
      { heading: 'Individual and Group Therapy', content: 'Our therapists provide individual and group therapy sessions to address a range of mental health concerns, including anxiety, depression, and trauma.' },
      { heading: 'Family Therapy', content: 'Our team provides family therapy to support loved ones and promote healthy communication and relationships.' },
      { heading: 'Cognitive-Behavioral Therapy (CBT)', content: 'Our therapists provide CBT to help individuals manage negative thought patterns and behaviors.' },
      { heading: 'Mindfulness-Based Therapies', content: 'Our therapists provide mindfulness-based therapies to promote relaxation, stress management, and emotional regulation.' },
    ],
  },
  {
    title: 'Specialized Programs',
    items: [
      { heading: 'Mood Disorders Program', content: 'Specialized services for individuals with depression, bipolar disorder, and other mood disorders.' },
      { heading: 'Anxiety Disorders Program', content: 'Specialized services for individuals with anxiety, including cognitive-behavioral therapy and mindfulness-based therapies.' },
      { heading: 'Trauma and Stress Management Program', content: 'Specialized services for individuals who have experienced trauma or stress.' },
      { heading: 'Substance Use Disorder Program', content: 'Specialized services for individuals struggling with addiction.' },
    ],
  },
];

const PsychiatricRehabilitation = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const handleToggle = (index) => setActiveIndex((prev) => (prev === index ? null : index));

  return (
    <div>
      <div className="medical-rehab-page">
        <header className="medical-rehab-header">
          <h1 className="medical-rehab-title">Psychiatric Rehabilitation</h1>
          <p className="medical-rehab-intro">
            Welcome to the Department of Psychiatric Rehabilitation at Dr. Bharathi Rao Advanced Comprehensive Rehabilitation Center
          </p>
          <p className="medical-rehab-description">
            At our esteemed institution, we recognize the importance of comprehensive psychiatric rehabilitation in promoting recovery and well-being for individuals with mental health conditions. Our department is dedicated to providing a range of in-patient and out-patient services tailored to the unique needs of every individual.
          </p>
        </header>

        <main className="medical-rehab-content">
          {sections.map((section, secIndex) => (
            <section key={secIndex} className="rehab-section">
              <h2 className="rehab-section-title">{section.title}</h2>
              <div className="rehab-accordion-grid">
                {section.items.map((item, idx) => {
                  const globalIdx = `${secIndex}-${idx}`;
                  const isActive = activeIndex === globalIdx;
                  return (
                    <div className={`rehab-accordion-item${isActive ? ' open' : ''}`} key={idx}>
                      <button
                        className="rehab-accordion-header"
                        onClick={() => handleToggle(globalIdx)}
                        aria-expanded={isActive}
                        aria-controls={`panel-${globalIdx}`}
                      >
                        <span className="icon">{isActive ? <ChevronUp /> : <ChevronDown />}</span>
                        {item.heading}
                      </button>
                      <div
                        id={`panel-${globalIdx}`}
                        className="rehab-accordion-body"
                        style={{ maxHeight: isActive ? '200px' : '0px' }}
                        aria-hidden={!isActive}
                      >
                        <p>{item.content}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </section>
          ))}

          <section className="rehab-commitment">
            <h2 className="rehab-section-title">Our Commitment</h2>
            <p>
              At Dr. Bharathi Rao Advanced Comprehensive Rehabilitation Center, we are committed to delivering high-quality, patient-centered care that promotes recovery and well-being for individuals with mental health conditions. Our team of experienced professionals is dedicated to creating a supportive and inclusive environment that fosters growth, development, and empowerment.
            </p>
          </section>

          {/* <section className="rehab-team">
            <h2 className="rehab-section-title">Meet Our Team</h2>
            <div className="rehab-team-grid">
              {teamMembers.map((member, idx) => (
                <div key={idx} className="rehab-team-card">
                  <div className="rehab-team-img">
                    <img src={member.image} alt={member.name} />
                  </div>
                  <div className="rehab-team-info">
                    <h3>{member.name}</h3>
                    <p className="role">{member.role}</p>
                    <p className="bio">{member.bio}</p>
                  </div>
                </div>
              ))}
            </div>
          </section> */}

          <section className="rehab-appointment">
            <h2 className="rehab-section-title">Book an Appointment</h2>
            <p>
              To know more about our Department of <strong>Psychiatric Rehabilitation</strong> or to schedule an appointment, click below and fill out our appointment request form.
            </p>
            <a
              href="https://forms.gle/3kjZMUiW6qRyKpRh9"
              target="_blank"
              rel="noopener noreferrer"
              className="appointment-btn"
            >
              Book Now
            </a>
          </section>
        </main>

      </div>
        <Footer />
    </div>
  );
};

export default PsychiatricRehabilitation;
